import React, { useEffect, useRef, useState } from 'react'
import MiniHeader from '../../components/global/MiniHeader'
import PropTypes from 'prop-types'
import noop from 'lodash/noop'
import { connect } from 'react-redux'
import { Container, Form, Row } from 'react-bootstrap'
import { Controller, useForm } from 'react-hook-form'
import { MaskedInput, createDefaultMaskGenerator } from 'react-hook-mask'
import { Circles } from 'react-loader-spinner'
// import { getFieldValue } from '../../utils/helper'
import { EMPTY_OBJECT, getSvgIcon } from '../../constants/globalConstants'
import { useDispatch } from 'react-redux'
import { updateProfile, resetPassword } from '../../redux/actions/profileAction'
import { restrictInValidCharPassword } from '../../utils/helper'
import { errorMessage } from '../../constants/errorMessage'
import { addEventLog } from '../../redux/actions/EventsLog'
import CONSTANTS from '../../redux/constants'
// import useremailimg from '../../assets/img/email.png'
// import userProfile from '../../assets/img/user.png'
// import userPhone from '../../assets/img/phone.png'



function Profile(props) {
    const { register, handleSubmit, formState: { errors }, control, watch, reset, setFocus, trigger, setValue } = useForm()
    const dispatch = useDispatch()
    const phoneRef = useRef(null)
    const { notify } = props


    const [tabs, setTabs] = useState(true)
    // const [profileData, setProfileData] = useState({ name: '', email: '', phone: '' })
    const [userData, setUserData] = useState(EMPTY_OBJECT)
    const [isLoading, setIsLoading] = useState(false)
    const phoneMaskGenerator = createDefaultMaskGenerator('(999) 999-9999')
    const [oldpasswordShown, setOldPasswordShown] = useState(false)
    const [passwordShown, setPasswordShown] = useState(false)
    const [cpasswordShown, setCPasswordShown] = useState(false)

    useEffect(() => {
        setFocus('name')
        phoneRef.current.blur()
        setTimeout(() => {
            setFocus('name')
            trigger('name', { shouldFocus: true })
        }, 500)
    }, [setFocus])

    useEffect(() => {
        setFocus('name')
        phoneRef.current.blur()
        setTimeout(() => {
            setFocus('name')
            trigger('name', { shouldFocus: true })
        }, 500)
    }, [setFocus])

    useEffect(() => {
        phoneRef.current.blur()
        setUserData(JSON.parse(localStorage.getItem('sign_in')))
    }, [])

    useEffect(() => {
        phoneRef.current.blur()
        // setProfileData({ name: userData?.user?.name, email: userData?.user?.email, phone: userData?.user?.phone })
        reset(formValues => ({ ...formValues, 'name': userData?.user?.name, 'email': userData?.user?.email, 'phone': userData?.user?.phone_number }))
    }, [userData])


    const handleTabs = (state) => {
        setTabs(state)
    }

    const togglePasswordVisiblity = (e, key) => {
        if (key === 'password') { setPasswordShown(passwordShown ? false : true) }
        if (key === 'password_confirmation') { setCPasswordShown(cpasswordShown ? false : true) }
        if (key === 'old_password') { setOldPasswordShown(oldpasswordShown ? false : true) }
    }

    const handledataSubmit = (data) => {
        // setSubmit(true)
        if (tabs) {
            setIsLoading(true)
            let formData = {
                name: data?.name,
                email: data?.email,
                phone: data?.phone
            }
            dispatch(updateProfile(formData)).then((res) => {
                const userData = res?.data
                setIsLoading(false)
                if (userData) {
                    notify('success', 'User Data Save Successfully')
                    let userdatalocal = JSON.parse(localStorage.getItem('sign_in'))
                    userdatalocal.user.name = userData?.name
                    userdatalocal.user.email = userData?.email
                    userdatalocal.user.phone_number = userData?.phone_number
                    localStorage.setItem('sign_in', JSON.stringify(userdatalocal))
                } else {
                    notify('error', res?.errors?.message ? res?.errors?.message : errorMessage?.somethingWentWrong)
                    let errObject = { 
                        payload: formData,
                        error: res,
                        errorMessage: res?.errors?.message ? res?.errors?.message : errorMessage?.somethingWentWrong
                    }
                    dispatch(addEventLog(errObject, `${CONSTANTS?.UNEXPECTED_ERROR} updateProfile-Profile.js-89`))
                }
            }).catch((err) => {
                const response = err?.errors
                let errObject = { 
                    payload: formData,
                    error: err,
                    errorMessage: err?.errors?.message ? err?.errors?.message : errorMessage?.somethingWentWrong
                }
                dispatch(addEventLog(errObject, `${CONSTANTS?.UNEXPECTED_ERROR} updateProfile-Profile.js-89`))
                notify('error', response?.message ? response?.message : errorMessage?.somethingWentWrong)
            })
        } else if (!tabs) {
            setIsLoading(true)
            let formData = {
                old_password: data?.old_password,
                password: data?.password,
                password_confirmation: data?.password_confirmation
            }
            dispatch(resetPassword(formData, userData?.user?.id)).then((res) => {
                const userData = res
                setIsLoading(false)
                if (userData?.data != null)
                    notify('success', 'Password change Successfully')
                else {
                    notify('error', res?.errors?.message ? res?.errors?.message : errorMessage?.somethingWentWrong)
                    const payload = {
                        formData: formData, 
                        userId: userData?.user?.id
                    }
                    let errObject = { 
                        payload: payload,
                        error: res,
                        errorMessage: res?.errors?.message ? res?.errors?.message : errorMessage?.somethingWentWrong
                    }
                    dispatch(addEventLog(errObject, `${CONSTANTS?.UNEXPECTED_ERROR} resetPassword-Profile.js-120`))
                }
            }).catch((err) => {
                const response = err?.errors
                const payload = {
                    formData: formData, 
                    userId: userData?.user?.id
                }
                let errObject = { 
                    payload: payload,
                    error: err,
                    errorMessage: err?.errors?.message ? err?.errors?.message : errorMessage?.somethingWentWrong
                }
                dispatch(addEventLog(errObject, `${CONSTANTS?.UNEXPECTED_ERROR} resetPassword-Profile.js-120`))
                notify('error', response?.message ? response?.message : errorMessage?.somethingWentWrong)
            })
        }
    }

    return (
        <div className='Pave'>
            <MiniHeader title={'EDIT MY DETAILS'} isDisplayBack />
            <Container className='mt-2'>
                <div className='border rounded me-3 w-100 d-flex'>
                    <div className={tabs ? 'tabs text-center bg-opacity-75 p-2 w-50 text-primary' : 'tabs text-center p-2 w-50 bg-grey text-secondary'} onClick={() => { handleTabs(true) }}  >
                        Profile
                    </div>
                    <div className={!tabs ? 'tabs text-center bg-opacity-75 p-2 w-50 text-primary bg-white' : 'tabs text-center p-2 w-50 bg-grey text-secondary'} onClick={() => { handleTabs(false) }}  >
                        Password
                    </div>
                </div>

                <div className='mt-4'>
                    <Form onSubmit={handleSubmit(handledataSubmit)}>
                        {tabs && <Row>
                            <Form.Group className="mb-3">
                                <Form.Label className='text-secondary fw-semibold'>Name </Form.Label>
                                <span className='cardNumberCardImage d-block'>
                                    <span className='imgIconInput2' style={{ height: '25px', width: '25px' }}>{getSvgIcon('USER', 'var(--bs-primary)')}</span>
                                    {/* <img src={userProfile} className='imgIconInput2' alt="card" /> */}
                                    <Form.Control
                                        type="text"
                                        id='name'
                                        placeholder="Name"
                                        className='padding-left-card text-secondary'
                                        name='name'
                                        maxLength='25'
                                        {...register('name', {
                                            required: { value: true, message: 'Please enter your name' },
                                            minLength: { value: 3, message: 'Please enter your name' },
                                            maxLength: 10,
                                        })}
                                    />
                                </span>
                            </Form.Group>
                            {(errors?.name) && <Form.Text className='text-danger header-s'>{errors?.name?.message}</Form.Text>}

                            <Form.Group className="mb-3">
                                <Form.Label className='text-secondary fw-semibold'>Email</Form.Label>
                                <span className='cardNumberCardImage d-block'>
                                    <span className='imgIconInput2' style={{ height: '23px', width: '23px' }}>{getSvgIcon('Email', 'var(--bs-primary)')}</span>
                                    <Form.Control
                                        type="text"
                                        id='email'
                                        placeholder="Email"
                                        name='email'
                                        disabled
                                        className='padding-left-card text-secondary'
                                        maxLength='25'
                                        {...register('email', {
                                            required: { value: true, message: 'Please enter a valid email address' },
                                            pattern: { value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i, message: 'Please enter a valid email address' },
                                        })}
                                    />
                                </span>
                            </Form.Group>
                            {(errors?.email) && <span className='text-danger header-s'>{errors?.email?.message}</span>}

                            <Form.Group className="mb-3">
                                <Form.Label className='text-secondary fw-semibold'>Phone Number</Form.Label>
                                <Controller
                                    name="phone"
                                    type="text"
                                    id="phone"
                                    control={control}
                                    inputMode="numeric"
                                    ref={phoneRef}
                                    rules={{
                                        required: { value: true, message: 'Please enter phone number' },
                                        minLength: { value: 10, message: 'Please enter a valid number' },
                                        maxLength: { value: 14, message: 'Please enter a valid numbedr' },
                                    }}
                                    render={({ field }) => <span className='cardNumberCardImage d-block'>
                                        <span className='imgIconInput2' style={{ height: '25px', width: '25px' }}>{getSvgIcon('Call', 'var(--bs-primary)')}</span>
                                        <MaskedInput
                                            maskGenerator={phoneMaskGenerator}
                                            className="form-control padding-left-card text-secondary"
                                            {...field}
                                            id="phone"
                                            ref={phoneRef}
                                            autoFocus={false}
                                            maxLength={14}
                                            inputMode="numeric"
                                            title="Please enter a valid phone number"
                                            onInvalid={e => e.target.setCustomValidity('Please enter phone number')}
                                            onInput={e => e.target.setCustomValidity('')}
                                            placeholder="(123)-555-1234"
                                        />
                                    </span>
                                    }
                                />
                            </Form.Group>
                            {errors?.phone && <Form.Text className="text-danger">{errors?.phone?.message}</Form.Text>}
                        </Row>
                        }

                        {!tabs && <Row>
                            <Form.Group className="mb-3">
                                <Form.Label className='text-secondary fw-semibold'>Old Password</Form.Label>
                                <span className='cardNumberCardImage d-block'>
                                    <i className={oldpasswordShown ? 'fas fa-eye-slash ChangePassIcon' : 'fas fa-eye ChangePassIcon'} onClick={(e) => togglePasswordVisiblity(e, 'old_password')}></i>
                                    <Form.Control
                                        type={oldpasswordShown ? 'text' : 'password'}
                                        id='old_password'
                                        placeholder="Password"
                                        name='old_password'
                                        maxLength='25'
                                        {...register('old_password', {
                                            required: { value: true, message: 'Please enter a valid password' },
                                            pattern: { value: /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?\d)(?=.*?[#?!@$%^&*-])[^()\\`~:;"/<>]{8,15}$/, message: 'Password must be between 8 and 15 characters long and include at least one uppercase letter, one lowercase letter, one digit (0-9), and one special character (!, @, $, %, ^, &, *, #,?,-).' }

                                        })}
                                    />
                                </span>
                            </Form.Group>
                            {(errors?.old_password) && <Form.Text className='text-danger header-s'>{errors?.old_password?.message}</Form.Text>}

                            <Form.Group className="mb-3">
                                <Form.Label className='text-secondary fw-semibold'>New Password</Form.Label>
                                <span className='cardNumberCardImage d-block'>
                                    <i className={passwordShown ? 'fas fa-eye-slash ChangePassIcon' : 'fas fa-eye ChangePassIcon'} onClick={(e) => togglePasswordVisiblity(e, 'password')}></i>
                                    <Form.Control
                                        type={passwordShown ? 'text' : 'password'}
                                        id='password'
                                        placeholder="New Password"
                                        name='password'
                                        maxLength='25'
                                        {...register('password', {
                                            required: { value: true, message: 'Please enter a valid password' },
                                            pattern: { value: /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?\d)(?=.*?[#?!@$%^&*-])[^()\\`~:;"/<>]{8,15}$/, message: 'Password must be between 8 and 15 characters long and include at least one uppercase letter, one lowercase letter, one digit (0-9), and one special character (!, @, $, %, ^, &, *, #,?,-).' },
                                            onChange: (e) => setValue(e.target.name, restrictInValidCharPassword(e.target.value))
                                        })}
                                    />
                                </span>
                            </Form.Group>
                            {(errors?.password) && <Form.Text className='text-danger header-s'>{errors?.password?.message}</Form.Text>}

                            <Form.Group className="mb-3">
                                <Form.Label className='text-secondary fw-semibold'>Confirm Password</Form.Label>
                                <span className='cardNumberCardImage d-block'>
                                    <i className={cpasswordShown ? 'fas fa-eye-slash ChangePassIcon' : 'fas fa-eye ChangePassIcon'} onClick={(e) => togglePasswordVisiblity(e, 'password_confirmation')}></i>
                                    <Form.Control
                                        type={cpasswordShown ? 'text' : 'password'}
                                        id='password_confirmation'
                                        placeholder="Confirm Password"
                                        name='password_confirmation'
                                        maxLength='25'
                                        {...register('password_confirmation', {
                                            required: { value: true, message: 'Please enter a valid Confirm password' },
                                            pattern: { value: /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?\d)(?=.*?[#?!@$%^&*-])[^()\\`~:;"/<>]{8,15}$/, message: 'Password must be between 8 and 15 characters long and include at least one uppercase letter, one lowercase letter, one digit (0-9), and one special character (!, @, $, %, ^, &, *, #,?,-).' },
                                            validate: (val) => {
                                                if (watch('password') != val) {
                                                    return 'Your passwords does not match'
                                                }
                                            },
                                            onChange: (e) => setValue(e.target.name, restrictInValidCharPassword(e.target.value))
                                        })}
                                    />
                                </span>
                            </Form.Group>
                            {(errors?.password_confirmation) && <Form.Text pan className='text-danger header-s'>{errors?.password_confirmation?.message}</Form.Text>}
                        </Row>}

                        <div className="mt-3">
                            <button type="submit" name="submit" className="btn w-100 my-4 text-white bg-primary" disabled={(isLoading)} >
                                <div className='d-flex justify-content-center align-items-center'>
                                    <span>{tabs ? 'Save My Details' : 'Change Password'} </span><span className='ms-2'>
                                        {(isLoading) ? <Circles
                                            height="20"
                                            width="20"
                                            style={{ display: 'inline-block' }}
                                            color="#ffffff"
                                            ariaLabel="circles-loading"
                                            visible={true}
                                        /> : null}
                                    </span>
                                </div>
                            </button>
                        </div>
                    </Form>
                </div>
            </Container>
        </div>
    )
}



Profile.propTypes = {
    notify: PropTypes.func,

}

Profile.defaulProps = {

    notify: noop

}

function mapStateToProps() {
    return {}
}
export default connect(mapStateToProps)(Profile)